import { api } from '@/lib/api'

import type { BankAccountConfig, BankDeposit, SmsWebhookLog } from './types'

export async function getSmsWebhookLogs(): Promise<SmsWebhookLog[]> {
  const res = await api.get('/api/sms-webhook-logs')
  return res.data.data ?? []
}

export async function getBankDeposits(): Promise<BankDeposit[]> {
  const res = await api.get('/api/bank-deposits')
  return res.data.data ?? []
}

export async function getBankAccountConfigs(): Promise<BankAccountConfig[]> {
  const res = await api.get('/api/bank-account-configs/')
  return res.data.data ?? []
}

export async function createBankAccountConfig(
  data: Omit<BankAccountConfig, 'id'>
): Promise<BankAccountConfig> {
  const res = await api.post('/api/bank-account-configs/', data)
  return res.data.data
}

export async function updateBankAccountConfig(
  id: number,
  data: Omit<BankAccountConfig, 'id'>
): Promise<void> {
  await api.put(`/api/bank-account-configs/${id}`, data)
}

export async function deleteBankAccountConfig(id: number): Promise<void> {
  await api.delete(`/api/bank-account-configs/${id}`)
}

export async function manualMatchDeposit(
  depositId: number,
  userId: number
): Promise<void> {
  await api.post(`/api/bank-deposits/${depositId}/manual-match`, {
    user_id: userId,
  })
}

